// extracted by mini-css-extract-plugin
module.exports = {"footer":"EmailForgotPasswordModal_footer__3Jfqw","label":"EmailForgotPasswordModal_label__3p8Pq"};